import {
  REQUEST_AUTHENTICATED,
  AUTHENTICATED_ERROR,
  UNAUTHENTICATED,
  AUTHENTICATED_USER,
  SHOULD_RESET_PASSWORD,
} from '../constants/authTypes';
import { VALIDATE_USER } from '../../constants/auth';

const initialState = {
  auth: false,
  email: null,
  loading: false,
  isError: false,
  currentStep: VALIDATE_USER,
  error: {},
  permissions: {
    retailers: false,
    suppliers: false,
  },
  shouldResetPassword: true,
};

const auth = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_AUTHENTICATED:
      return {
        ...state,
        auth: false,
        email: action.payload,
        loading: true,
      };

    case AUTHENTICATED_USER:
      return {
        ...state,
        auth: true,
        loading: false,
        isError: false,
        errorCode: '',
        currentStep: action.payload.currentStep,
      };

    case UNAUTHENTICATED:
      return {
        ...state,
        auth: false,
        email: null,
        loading: false,
        currentStep: VALIDATE_USER,
      };

    case AUTHENTICATED_ERROR:
      return {
        ...state,
        auth: true,
        email: null,
        loading: false,
        isError: true,
        error: action.payload,
      };
    case SHOULD_RESET_PASSWORD:
      return {
        ...state,
        auth: true,
        email: null,
        loading: false,
        shouldResetPassword: action.payload,
      };

    default:
      break;
  }
  return state;
};

export default auth;
